/* eslint-disable no-mixed-spaces-and-tabs,no-tabs */

import * as moment from 'moment';

xplenty.filter('prettydateUTC', [
  function () {
    return function (value) {
      return value ? `${moment(value).utc().format('YYYY-MM-DD HH:mm')} UTC` : '';
    };
  },
]);
